import { Localization } from "@viamap/viamap2-common";
import { LayerInfo } from "src/common/managers/Types";
import { Fragment, useContext, useState } from "react";
import { ADModalBody, ADModalFooter, ADModalInfo, AdvancedDragModal } from "src/componentsUtils/AdvancedDragModal";
import { GlassButton } from "./GlassButtons";
import { actionAddDataLayer, MapitStateContext } from "src/states/MapitState";
import { ManagedWindow } from "src/WindowManager/WindowState";


type Props = {
  managedWindow: ManagedWindow;
  layers?: LayerInfo | LayerInfo[]
  selectedByDefault?: boolean[]
  onClose: () => void;
};
export function NameOnCreation(props: Props) {
  const { dispatch: mapitStateDispatch } = useContext(MapitStateContext);

  let layers = !props.layers ? [] : "type" in props.layers ? [props.layers] : props.layers
  const [name, setName] = useState(layers.map((a) => a.datasetname))
  const [selected, setSelected] = useState(layers.map((_layer, idx) => props.selectedByDefault?.[idx] ?? true))
  const useLayerSelection = props.selectedByDefault !== undefined
  const canAccept = !useLayerSelection || selected.some(Boolean)

  function updateName(value: string, idx: number) {
    setName((name) => name.map((a, idy) => idx === idy ? (value ?? "") : a))
  }

  function updateSelected(value: boolean, idx: number) {
    setSelected((selected) => selected.map((a, idy) => idx === idy ? value : a))
  }

  function Accept() {
    if (!canAccept) {
      return
    }
    let newLayers = layers.map((layer, idx) => ({
      ...layer,
      datasetname: name[idx] || layer.datasetname
    })).filter((_layer, idx) => !useLayerSelection || selected[idx])
    newLayers.forEach((layer) => {
      mapitStateDispatch(actionAddDataLayer(layer as any));
    })
    props.onClose()
  }

  function Cancel() {
    props.onClose()
  }


  return <AdvancedDragModal
    window={props.managedWindow}
    PosDefault={{ left: "50%", top: "10%", transform: "translateX(-50%)", width: "500px" }}
    title={Localization.getText("Rename")}
  >
    <ADModalInfo>
      {name.length < 2 ? Localization.getText("Change the name of new the layer before adding it to the list") : Localization.getText("Change the names of the new layers before they are added to the list")}
    </ADModalInfo>
    <ADModalBody>
      {layers.map((layer, idx) => {
        return (<Fragment key={layer.datasetname ?? "Error"}>
          <div style={{ color: "grey", textAlign: "left", fontSize: "11px" }}>{Localization.getText("Layer") + ": " + (idx + 1)}</div>
          <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
            {useLayerSelection ? <input checked={selected[idx]} onChange={(ev) => updateSelected(ev.target.checked, idx)} type="checkbox" /> : null}
            <input autoFocus={idx == 0} disabled={useLayerSelection && !selected[idx]} style={{ color: "black", paddingLeft: "6px", flex: 1 }} type="text" value={name[idx]} placeholder={layer.datasetname ?? "Error"} onChange={(ev) => updateName(ev.target.value, idx)}
              onKeyDown={(e) => {
                if (idx == 0 && e.code == "Enter" && canAccept) {
                  Accept();
                } else if (layers.length - 1 == idx && e.code == "Escape") {
                  Cancel();
                }
              }}
            />
          </div>
        </Fragment>)
      })}
    </ADModalBody>
    <ADModalFooter>
      <GlassButton disabled={!canAccept} onClick={() => Accept()}>{Localization.getText("Save")}</GlassButton>
      <GlassButton onClick={() => Cancel()}>{Localization.getText("Close")}</GlassButton>
    </ADModalFooter>
  </AdvancedDragModal>
}